import { render } from "./TotalRevenue.vue?vue&type=template&id=89866554&scoped=true"
import script from "./TotalRevenue.vue?vue&type=script&lang=js"
export * from "./TotalRevenue.vue?vue&type=script&lang=js"

import "./TotalRevenue.vue?vue&type=style&index=0&id=89866554&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89866554"]])

export default __exports__